<template>
  <div id="app" :style="isMicroApp ? '' : { minWidth: '1024px' }">
    <a-config-provider :locale="getValidLocale">
      <router-view @languageChange="languageChange" />
    </a-config-provider>
  </div>
</template>
<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import en_US from "ant-design-vue/lib/locale-provider/en_US";
import moment from "moment";
import "moment/locale/zh-cn";

export default {
  data() {
    return {
      zh_CN,
      en_US,
      locale: localStorage.getItem('i18n') || 'en',
      isMicroApp: false,
    };
  },
  created() {
    moment.locale(localStorage.getItem('i18n') || 'en');
  },
  mounted() {
    this.languageChange()

    var t = window.devicePixelRatio   // 获取下载的缩放 125% -> 1.25    150% -> 1.5
    if (t != 1) {   // 如果进行了缩放，也就是不是1
      document.body.style.zoom = -0.6 * t + 1.55;   // 就去修改页面的缩放比例，这个公式我自己算的，不准确，勉强。
    }
    document.body.style.zoom = 1
    this.isMicroApp = !!window.__MICRO_APP_ENVIRONMENT__

  },
  computed: {
    getValidLocale() {
      if (this.locale.startsWith('zh')) {
        return this.zh_CN;
      } else if (this.locale.startsWith('en')) {
        return this.en_US;
      } else {
        return this.en_US;
      }

    }
  },
  methods: {
    languageChange() {
      this.locale = localStorage.getItem('i18n') || 'en';
      moment.locale(localStorage.getItem('i18n')|| 'en') ;
    },

  }

};
</script>

<style lang="less">
.ant-layout {
  background: #f3f3f3;
}

// 页面中标题添加竖线装饰
.Chart-Tab-Name {
  padding-left: 10px;
  position: relative;
}

.Chart-Tab-Name::before {
  content: "";
  width: 5px;
  height: 27px;
  position: absolute;
  top: 18px;
  left: 0;
  background: #efe251;
}

.page-title {
  padding-left: 10px;
  position: relative;
}

.ant-menu.ant-menu-dark .ant-menu-item-selected,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  background-color: #7f8c9e;
}

.th-first-style {
  text-align: left !important;
  line-height: 36px;
}

.th-style {
  line-height: 36px;
  text-align: left !important;
}

//侧边菜单颜色
.ant-menu-submenu-title {
  margin-top: 0px !important;
}

//子菜单颜色
/*.mark ul {*/
/*  background-color: black !important;*/
/*}*/
.ant-tooltip {
  max-width: 700px;
}

.ant-table-thead>tr>th {
  background: transparent;
}

html {
  --antd-wave-shadow-color: #000000;
}

div {}

/* ---------- pagination ---------- */
.ant-pagination {
  text-align: right !important;
}

.ant-table-pagination.ant-pagination {
  float: none;
}

.ant-pagination-item-active {
  background-color: #FFBC0D;
  color: #000000 !important;
  font-weight: 500 !important;
  // background-color: rgba(0,0,0,.85);
  border-color: rgba(0, 0, 0, 0) !important;
}

.ant-pagination-item-active a,
.ant-pagination-item-active:focus a,
.ant-pagination-item-active:hover a {
  // color: rgba(255,255,255,.85);
  color: rgba(0, 0, 0, .85);
}

.ant-pagination-item:focus,
.ant-pagination-item:hover {
  border-color: rgba(0, 0, 0, .85);
}

.ant-pagination-item:not(.ant-pagination-item-active):hover a,
.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon,
.ant-pagination-next:not(.ant-pagination-disabled),
.ant-pagination-prev:not(.ant-pagination-disabled) {
  color: rgba(0, 0, 0, .85);
}

.ant-pagination-prev:not(.ant-pagination-disabled):hover .ant-pagination-item-link,
.ant-pagination-next:not(.ant-pagination-disabled):hover .ant-pagination-item-link {
  color: rgba(0, 0, 0, .85);
  border-color: rgba(0, 0, 0, .85);
}

.ant-pagination-prev:not(.ant-pagination-disabled):focus .ant-pagination-item-link,
.ant-pagination-next:not(.ant-pagination-disabled):focus .ant-pagination-item-link {
  color: rgba(255, 255, 255, .85);
  background-color: rgba(0, 0, 0, .85);
  border-color: rgba(0, 0, 0, .85);
}


/* ---------- select ---------- */
.ant-select-selection {
  color:#898989
}
.ant-select-focused .ant-select-selection,
.ant-select-selection:focus,
.ant-select-selection:active {
  border-color: rgba(0, 0, 0, .85);
  -webkit-box-shadow: 0 0 0 2px rgba(0, 0, 0, .1);
  box-shadow: 0 0 0 2px rgba(0, 0, 0, .1);
}

.ant-select-open .ant-select-selection {
  -webkit-box-shadow: 0 0 0 2px rgba(0, 0, 0, .1);
  box-shadow: 0 0 0 2px rgba(0, 0, 0, .1);
}

.ant-select-selection:hover {
  border-color: rgba(0, 0, 0, .85);
}

.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {
  //color: rgba(255,255,255,.85);
  //background-color: rgba(0,0,0,.85);
  color: rgba(0, 0, 0, .85);
  background-color: rgba(154, 205, 252, 0.10);
  // background-color: var(--main-color);
}

.ant-select-dropdown-menu-item-selected {
  color: rgba(0, 0, 0, .85);
  //background-color: rgba(0,0,0,.85);
  background-color: rgba(154, 205, 252, 0.10);
  // background-color: var(--main-color);
}

.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled) {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, .85);
}

.ant-pagination-options-quick-jumper input:hover {
  border-color: rgba(0, 0, 0, .85);
}

.ant-pagination-options-quick-jumper input:focus {
  border-color: rgba(0, 0, 0, .85);
  -webkit-box-shadow: 0 0 0 2px rgba(0, 0, 0, .1);
  box-shadow: 0 0 0 2px rgba(0, 0, 0, .1);
}

/*  ant-btn  */
.ant-btn:not([disabled]) {
  color: rgba(0, 0, 0, 0.85);
  border: 1px solid #d9d9d9;
}

.ant-btn:not([disabled]):hover,
.ant-btn:not([disabled]):focus {
  color: rgba(0, 0, 0, 0.85);
  border: 1px solid #000000;
}

.ant-btn-primary:not([disabled]) {
  // color: rgba(255,255,255,0.85);
  // background-color: #000000;
  // color: rgba(255,255,255,0.85);
  color: var(--font-color);
  background-color: var(--main-color);
  //border-color: #000000;
}

.ant-btn-primary:not([disabled]):hover,
.ant-btn-primary:not([disabled]):focus {
  // color: rgba(255,255,255,0.85);
  // background-color: #262626;
  color: #000000;
  background-color: var(--main-color);
  border-color: #000000;
}

.ant-btn-background-ghost.ant-btn-primary:not([disabled]) {
  color: rgba(0, 0, 0, 0.85);
  border-color: #000000;
}

.ant-btn-background-ghost.ant-btn-primary:not([disabled]):hover,
.ant-btn-background-ghost.ant-btn-primary:not([disabled]):focus {
  color: rgba(0, 0, 0, 0.85);
  border-color: #262626;
}

.ant-btn-danger:not([disabled]) {
  color: rgba(255, 255, 255, 0.85);
  background-color: #dd0031;
  border-color: #dd0031;
}

.ant-btn-danger:not([disabled]):hover,
.ant-btn-danger:not([disabled]):focus {
  color: rgba(255, 255, 255, 0.85);
  background-color: #da4768;
  border-color: #da4768
}

.ant-btn-background-ghost.ant-btn-danger:not([disabled]) {
  color: #dd0031;
  border-color: #dd0031;
}

.ant-btn-background-ghost.ant-btn-danger:not([disabled]):hover,
.ant-btn-background-ghost.ant-btn-danger:not([disabled]):focus {
  /*color: #f5446b;*/
  color: #ff4f4f;
  border-color: #ff4f4f
}

.ant-btn-link:not([disabled]) {
  font-size: 14px;
  font-weight: 400;
  color: rgba(212, 27, 133, 0.60);
  border: none;
}

.ant-btn-link:not([disabled]):hover,
.ant-btn-link:not([disabled]):focus {
  font-size: 14px;
  font-weight: 400;
  color: rgba(212, 27, 133, 0.50);
  border: none;
}

.ant-btn-link.danger-link:not([disabled]) {
  font-size: 14px;
  font-weight: 400;
  color: #FF4F4F;
  border: none;
}

.ant-btn-link.danger-link:not([disabled]):hover,
.ant-btn-link.danger-link:not([disabled]):focus {
  font-size: 14px;
  font-weight: 400;
  color: #FF4F4F;
  border: none;
}

.ant-btn-link.primary-link:not([disabled]) {
  font-size: 14px;
  font-weight: 400;
  color: #6AB2DF;
  border: none;
}

.ant-btn-link.primary-link:not([disabled]):hover,
.ant-btn-link.primary-link:not([disabled]):focus {
  font-size: 14px;
  font-weight: 400;
  color: #6AB2DF;
  border: none;
}

.ant-radio-wrapper span {
  color: #898989 ;
}

/*  ant-input  */
.ant-input {
  border: 1px solid #d9d9d9;
  color: #898989;
  font-weight: 400;
}

.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled),
.ant-input-affix-wrapper .ant-input:not(.ant-input-disabled):focus {
  border: 1px solid rgba(0, 0, 0, 0.85);
  color: rgba(0, 0, 0, 0.85);
  font-weight: 400;
}

.ant-input-affix-wrapper .ant-input:not(.ant-input-disabled):focus {
  -webkit-box-shadow: 0 0 0 2px rgba(0, 0, 0, .1);
  box-shadow: 0 0 0 2px rgba(0, 0, 0, .1);
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
}

.ant-input:focus {
  border-color: #000000;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, .1);
}

.ant-input:hover {
  border-color: #000000;
}

/*  ant-table-row  */
.ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
.ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
.ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background-color: #F4FBFF;
}

.ant-table-thead>tr.ant-table-row-selected>td,
.ant-table-tbody>tr.ant-table-row-selected>td {
  background-color: #F4FBFF;
}

.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background-color: #000000;
}

/*  ant-step  */
.ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title::after {
  background-color: rgb(0 0 0 / .85);
}

.ant-steps-item-finish .ant-steps-item-icon>.ant-steps-icon {
  color: rgb(0 0 0 / .85);
}

/*  ant-dropdown  */
a {
  color: #6AB2DF;
}

a:hover {
  cursor: pointer;
  color: #6AB2DF;
}

.ant-dropdown-menu-item a {
  color: rgba(0, 0, 0, .85);
}

.ant-dropdown-menu-item:hover,
.ant-dropdown-menu-submenu-title:hover {
  background-color: #f5f5f5;
}

/*  ant-tab  */
.ant-tabs {
  color: #898989;
}

.ant-tabs-nav {
  font-weight: 500;
}

.ant-tabs-nav .ant-tabs-tab-active {
  color: rgba(0, 0, 0, 0.85);
}

.ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-disabled):active,
.ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-disabled):hover,
.ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-disabled):focus {
  color: rgba(0, 0, 0, 1);
}

.ant-tabs-ink-bar {
  background-color: #000000
}

.tab-gradient .ant-tabs-nav .ant-tabs-tab-active {
  color: rgba(0, 0, 0, 0.85);
  border-radius: 5px;
  //background-image: linear-gradient(to right, #908D7C, #908D7C, #C6C2BB, #C6C2BB, #EEECE4, #EEECE4);
  background-image: linear-gradient(to right, #FFBE00, #FFBE00);
  // background-image: linear-gradient(to right, #CAEBFF, #CCE9FE, #D6E2FB, #DDDDF9, #E1DAF7, #E7D6F6);
}

.tab-gradient .ant-tabs-ink-bar {
  background-color: rgba(0, 0, 0, 0);
  //background-image: linear-gradient(to right, #908D7C, #908D7C, #C6C2BB, #C6C2BB, #EEECE4, #EEECE4);
  // background-image: linear-gradient(to right, #CAEBFF, #CCE9FE, #D6E2FB, #DDDDF9, #E1DAF7, #E7D6F6);
}

// 2021-2-7 tabs type 改为card
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  width: 64px;
  height: 32px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  border-radius: 5px;
  border: none;
  background-color: rgba(0, 0, 0, 0);
  //background-image: linear-gradient(to right, #908D7C, #908D7C, #C6C2BB, #C6C2BB, #EEECE4, #EEECE4);
  // background-image: linear-gradient(to right, #CAEBFF, #CCE9FE, #D6E2FB, #DDDDF9, #E1DAF7, #E7D6F6);
}

.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
  width: 64px;
  height: 32px;
  border: none;
  border-radius: 5px 5px 5px 5px;
  background-color: transparent;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

/*  ant-radio-group  */
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: rgba(0, 0, 0, 0.85);
  background: #efe251;
  border-color: #000000;
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: rgba(0, 0, 0, 0.85);
  background: #efe251;
  border-color: #000000;
}

.ant-radio-group-solid .ant-radio-button-wrapper:hover {
  color: rgba(0, 0, 0, 0.85);
  border-color: #000000;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  box-shadow: -1px 0 0 0 rgba(0, 0, 0, .1);
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  box-shadow: -1px 0 0 0 rgba(0, 0, 0, .85);
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
  outline: 3px solid rgba(0, 0, 0, .1);
}

/*  ant-radio  */
.ant-radio-wrapper span {
  color: #000000;
  font-size: 14px;
}

.ant-radio-checked .ant-radio-inner {
  border-color: #FBBE02;
}

.ant-radio-inner::after {
  background-color: #FBBE02;
}

.ant-radio-checked::after {
  background-color: #000000;
}

.ant-radio-wrapper:hover .ant-radio,
.ant-radio:hover .ant-radio-inner,
.ant-radio-input:focus+.ant-radio-inner {
  border-color: #000000;
}

.ant-radio-input:focus+.ant-radio-inner {
  box-shadow: 0 0 0 3px rgba(0, 0, 0, .1);
}

/*  ant-checkbox  */
.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus+.ant-checkbox-inner {
  border-color: #000000;
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #000000;
  color: rgba(255, 255, 255, .85);
  border-color: #000000;
}

.ant-checkbox-checked::after {
  border: 1px solid #000000;
}

/*  ant-datepick  */
.ant-calendar-today .ant-calendar-date {
  color: rgba(0, 0, 0, .85);
  border-color: #000000;
}

.ant-calendar-selected-day .ant-calendar-date {
  background: none;
}

.ant-calendar-selected-date .ant-calendar-date {
  color: rgba(255, 255, 255, .85);
  background: #000000;
}

.ant-calendar-date:active {
  color: rgba(255, 255, 255, .85);
}

.ant-calendar-date:hover {
  background: none;
  color: rgba(0, 0, 0, .85);
  border-color: #000000;
}

.ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled) {
  border-color: #000000;
}

.ant-calendar-today-btn {
  color: rgba(0, 0, 0, .85);
}

.ant-calendar-today-btn:hover,
.ant-calendar-today-btn:focus {
  color: rgba(0, 0, 0, 1);
}

.ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date,
.ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date,
.ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date:hover,
.ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date:hover {
  background: #000000;
  color: rgba(255, 255, 255, .85);
  font-weight: 400;
}

.ant-calendar-range .ant-calendar-in-range-cell::before {
  background: none;
  border-bottom: 1px solid #000000;
  color: #000000
}

.ant-calendar-picker:focus .ant-calendar-picker-input:not(.ant-input-disabled) {
  border-color: rgba(0, 0, 0, .85);
  box-shadow: 0 0 0 2px rgba(0, 0, 0, .1);
}

/*.ant-tag-blue {*/
/*  color: rgba(255,255,255,.85);*/
/*  background: #000000;*/
/*  border-color: #000000;*/
/*}*/
.ant-calendar-header a:hover {
  color: #DD0031;
}

.ant-calendar-year-panel-cell a:hover,
.ant-calendar-decade-panel-decade:hover,
.ant-calendar-month-panel-month:hover {
  border: 1px solid #000000;
  color: rgba(0, 0, 0, .85);
  background: none;
}

.ant-calendar-decade-panel-cell a:hover,
.ant-calendar-month-panel-cell a:hover {
  color: rgba(0, 0, 0, .85);
}

.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year,
.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year:hover,
.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade,
.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade:hover,
.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month,
.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month:hover {
  background: #000000;
  color: rgba(255, 255, 255, .85);
  border: 1px solid #000000;
}

.ant-calendar-week-number .ant-calendar-body tr.ant-calendar-active-week {
  background: rgba(0, 0, 0, .1);
}

.ant-calendar-week-number .ant-calendar-body tr:hover {
  background: none;
  border-bottom: 1px solid #000000;
}

/*  ant-input-number  */
.ant-input-number:hover {
  border-color: #000000;
}

.ant-input-number:focus,
.ant-input-number-focused {
  border-color: #000000;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, .1);
}

/*  ant-select-tree-checkbox  */
.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner::after {
  background-color: #000000;
}

.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox:hover .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox-input:focus+.ant-select-tree-checkbox-inner {
  border-color: #000000;
}

.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {
  background-color: #000000;
  border-color: #000000;
}

.ant-select-tree-checkbox-checked::after {
  border: 1px solid #000000;
}

/*  ant-select-tree  */
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected .ant-select-selected-icon {
  //color: rgba(255,255,255,.85);
  color: #9acdfc;
}

.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:hover .ant-select-selected-icon {
  //color: rgba(0,0,0,.85);
  color: #9acdfc;
}

.ant-select-tree li .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {
  color: rgba(255, 255, 255, .85);
  background-color: var(--main-color);
}

.ant-select-tree li .ant-select-tree-node-content-wrapper.ant-select-tree-node-content-wrapper-normal:hover {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, .85);
}

.ant-select-tree li .ant-select-tree-node-content-wrapper.ant-select-tree-node-content-wrapper-open:hover {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, .85);
}

/*  ant-slider  */
.ant-slider-track {
  background-color: rgba(0, 0, 0, .85);
}

.ant-slider-handle {
  border: solid 2px rgba(0, 0, 0, .85);
}

.ant-slider-handle:focus {
  border-color: rgba(0, 0, 0, .85);
  box-shadow: 0 0 0 5px rgba(0, 0, 0, .1);
}

.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
  border-color: rgba(0, 0, 0, .6);
}

.ant-slider-handle.ant-tooltip-open {
  border-color: rgba(0, 0, 0, .85);
}

.ant-slider:hover .ant-slider-track {
  background-color: rgba(0, 0, 0, .6);
}

// .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
//   background-image: linear-gradient(to right, #FFBE00, #F9A53D, #FFBC0D,#FFBE00, #FEC750);background-image: linear-gradient(to right, #FFED5D, #FEC750, #F9A53D, #FFBC0D, #FEC750, #FFED5D);
//   color: black;
//   // background-image: linear-gradient(to right, #EEECE4 , #EEECE4,#908D7C,#908D7C,#EEECE4,#EEECE4);

// }
//搜索卡片
.search {
  margin: 20px 0;
}

.search .ant-input-group-addon {
  color: #000000;
}

.search .ant-input-group-addon:first-child {
  border: none !important;
  background-color: transparent !important;
}

.search .ant-input-group-addon {
  padding: 0;
}

.ant-card .ant-layout-header {
  background: #FFFFFF;
  padding: 0px;
  margin-top: -20px;
}

.chartDiv .ant-layout-header {
  background: #FFFFFF;
  padding: 0px;
}

//卡片边框修改为圆角kevin 20200113
.ant-card-bordered {
  border-radius: 5px;
  border: none;
}

.ant-card-head {
  border: none;
}

//首页第一个chart-1 样式
.chart-1 .ant-card-body {
  padding: 0px;
  margin-left: 24px;
}

//top table
.topTable .ant-table.ant-table-bordered .ant-table-title {
  padding-right: 0;
  padding-left: 0;
  border: none;
}

.topTable .ant-table-title {
  position: relative;
  padding: 0;
  border: none;
}

.topTable .ant-table-tbody>tr>td {
  border-bottom: none;
}

// 每页标题样式
.page-title {
  font-size: 20px;
  font-weight: 600;
  margin-left: 10px;
  color: rgba(0, 0, 0, .85);
}

.ant-card-head-title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, .85);
}

.content {
  margin-top: 30px;
}

.content .title {
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
  line-height: 26px;
  margin: 27px 0;
}

.input-number-no-icon .ant-input-number-handler-wrap {
  display: none;
}

//ant tooltip样式
.ant-tooltip-inner {
  // background: white !important;
  // color: rgba(0,0,0,0.85);
  font-family: "PingFangSC";
  font-size: 12px;
}

.ant-tooltip-arrow::before {
  background-color: white !important;
}

.anticon-question-circle {
  cursor: pointer;
}

// table style
.ant-table-thead>tr>th {
  // color: #000000;
  font-weight: 600;
  font-size: 14px;
}

.ant-table-tbody>tr>td {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.ant-modal-title {
  color: #000000;
  font-weight: 600;
  text-align: center;
}

.ant-form-item-label>label {
  color: #000000;
  text-shadow: 0px 2px 11px rgba(0, 0, 0, 0.23);
}

.ant-form-item {
  margin-bottom: 16px;
}

.ant-select .ant-select-arrow {
  color: rgba(0, 0, 0, .9);
}

.ant-select-selection__choice__content {
  color: #000000;
  text-shadow: 0px 2px 11px rgba(0, 0, 0, 0.23);
  font-size: 13px;
}

.ant-select-selection--multiple .ant-select-selection__choice__remove {
  color: rgba(0, 0, 0, .9);
}

.ant-select {
  color: #000000;
  text-shadow: 0px 2px 11px rgba(0, 0, 0, 0.23);
}

.ant-select-selection__placeholder,
.ant-select-search__field__placeholder {
  text-shadow: none;
}

.ant-form label {
  font-size: 15px;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
  background-color: none;
}

.ant-modal-body {
  //padding-left: 60px;
}

.ant-cascader-menu-item-active {
  background-color: var(--main-color) !important;
}


.ant-cascader-picker:focus .ant-cascader-input,
.ant-cascader-picker-focused .ant-cascader-input,
.ant-select-focused .ant-select-selection,
.ant-select-selection:focus,
.ant-select-selection:active,
.ant-select-selection:hover,
.ant-input-number:hover,
.ant-input-number:focus,
.ant-input-number-focused,
.ant-input:focus,
.ant-input:hover,
.ant-calendar-picker:focus .ant-calendar-picker-input:not(.ant-input-disabled),
.ant-select-dropdown-menu-item-selected {
  border-color: var(--main-color) !important;
  box-shadow: none !important;
}

.ant-message-notice .anticon,
// confirm 取消提示icon
.ant-modal-confirm-warning .ant-modal-confirm-body>.anticon,
.ant-modal-confirm-confirm .ant-modal-confirm-body>.anticon {
  color: var(--main-color) !important;
}

.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background: var(--main-color);
  color: var(--font-color);
}

.ant-timeline-item-head-blue {
  border-color: var(--main-color);
}
</style>
